function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { GitMergeIcon, GitPullRequestIcon, IssueClosedIcon, IssueOpenedIcon, QuestionIcon } from '@primer/octicons-react';
import React from 'react';
import styled from 'styled-components';
import { variant } from 'styled-system';
import { COMMON, get } from './constants';
import StyledOcticon from './StyledOcticon';
import sx from './sx';
import theme from './theme';
const octiconMap = {
  issueOpened: IssueOpenedIcon,
  pullOpened: GitPullRequestIcon,
  issueClosed: IssueClosedIcon,
  pullClosed: GitPullRequestIcon,
  pullMerged: GitMergeIcon,
  draft: GitPullRequestIcon
};
const colorVariants = variant({
  prop: 'status',
  scale: 'stateLabels.status'
});
const sizeVariants = variant({
  prop: 'variant',
  scale: 'stateLabels.sizes'
});
const StateLabelBase = styled.span.withConfig({
  displayName: "StateLabel__StateLabelBase",
  componentId: "k4pd9e-0"
})(["display:inline-flex;align-items:center;font-weight:600;line-height:16px;color:", ";text-align:center;border-radius:", ";", ";", ";", ";", ";"], get('colors.white'), get('radii.3'), colorVariants, sizeVariants, COMMON, sx);
function StateLabel(_ref) {
  let {
    children,
    status,
    variant,
    ...rest
  } = _ref;
  const octiconProps = variant === 'small' ? {
    width: '1em'
  } : {};
  return /*#__PURE__*/React.createElement(StateLabelBase, _extends({}, rest, {
    variant: variant,
    status: status
  }), status && /*#__PURE__*/React.createElement(StyledOcticon, _extends({
    mr: 1
  }, octiconProps, {
    icon: octiconMap[status] || QuestionIcon
  })), children);
}
StateLabel.displayName = "StateLabel";
StateLabel.defaultProps = {
  theme,
  variant: 'normal'
};
export default StateLabel;